module.exports = __webpack_public_path__ + "img/sanzhongyida.883fbac5.png";